'use strict';

const addressModel = require('./addressModel');
const addEditAddress = require('./addEditAddressTab');
const geocode = require('./geocode');
const deliveryUtils = require('./deliveryUtils');

//Delivery Tab
let $deliveryTab = null;
let $deliveryTabContent = null;
let $deliveryInput = null;
let $deliveryButton = null;
let $deliveryLabel = null;
let $notificationMessage = null;
let $notificationContainer = null;
let selectedDeliveryAddress = null;
let $emptyStateHint = null;

/**
 * Defines what will do when an user clicks on a saved address
 */
function setSavedAddresClick($savedAddresesContainer) {
    const itemIconURL = $savedAddresesContainer.attr('data-item-icon-url');
    const selectedItemIconURL = $savedAddresesContainer.attr('data-selected-item-icon-url');
    const invalidAddressIconURL = $savedAddresesContainer.attr('data-invalid-address-icon-url');
    const notInRangeIconURL = $('.list-group:is(.selected-address-group, .savedAddress-selected), .list-group').data('not-in-range-icon');
    const errorMsgs = {
        unavailable: $savedAddresesContainer.data('error-msg-geocoder-unavailable'),
        notfound: $savedAddresesContainer.data('error-msg-geocoder-notfound'),
    };

    $savedAddresesContainer.on('click', '.list-group-item', async function () {
        const selectedAddress = $(this).data('address-info');
        let location;

        //Reset selected status
        $savedAddresesContainer.find('.list-group-item').removeClass('address-selected');
        $('.list-group.selected-address-group').find('.list-group-item').removeClass('item-selected');
        $savedAddresesContainer.find('.list-group-item').each(function () {
            const $item = $(this);
            const $img = $item.find('img');

            if ($item.hasClass('address-invalid')) {
                $img.attr('src', invalidAddressIconURL);
            } else if ($item.hasClass('not-in-range')) {
                $img.attr('src', notInRangeIconURL);
            } else {
                $img.attr('src', itemIconURL);
            }
        });
        //Selects store clicked
        if (!($(this).hasClass('address-invalid')) && !($(this).hasClass('not-in-range'))) {
            $(this).find('img').attr('src', selectedItemIconURL);
            $(this).addClass('address-selected');
            $deliveryButton.removeClass('d-none');
            $deliveryButton.attr('disabled', false);

            if (selectedAddress.lat && selectedAddress.lng) {
                location = new google.maps.LatLng(
                    parseFloat(selectedAddress.lat),
                    parseFloat(selectedAddress.lng)
                );
            } else {
                location = await geocode.fetchLatLngFromAddress(selectedAddress.addressDetails, errorMsgs);
            }
            if (location) {
                SetSelectedAddresDataFromLocation(location, selectedAddress);

                if (!selectedAddress.lat && !selectedAddress.lng) { // Save lat/lon to addressbook if they are not already saved
                    $.ajax({
                        url: $('#delivery-tab-pane').data('update-coordinates-url'),
                        method: 'POST',
                        data: {
                            addressName: selectedAddress.name,
                            latitude: location.lat(),
                            longitude: location.lng()
                        }
                    });
                }
            }
        }
    });
}

function SetSelectedAddresDataFromLocation(location, selectedAddress) {
    selectedDeliveryAddress = {
        lat: location.lat(),
        lng: location.lng(),
        addressDetails: selectedAddress.addressDetails,
        name: selectedAddress.name,
        zipCode: selectedAddress.zipCode,
        stateCode: selectedAddress.stateCode,
        isFromAddressBook: true
    };
}

function initSavedAddressesState() {
    const savedAddresses = $deliveryTabContent.find('.list-group-saved-addreses').children();

    if (deliveryUtils.isDeliveryAddressSet()) {
        const { deliveryAddress } = deliveryUtils.getDeliveryAddress();
        savedAddresses.each(function() {
            const $selectedItem = $(this);
            const savedAddressInfo = $selectedItem.data('address-info');
            if (savedAddressInfo.name.toUpperCase() === deliveryAddress.addressName.toUpperCase()) {
                const $container = $selectedItem.parent()
                const iconUrl = $container.data('active-item-icon-url');
                $selectedItem.find('.saved-address-img').attr('src', iconUrl);
                $selectedItem.prependTo($container);
                $selectedItem.addClass('address-active');
                $deliveryTabContent.find('.list-group').addClass('savedAddress-selected');
                return false;
            }
        });
    }
}

function showSavedAddresesSection(response, selectAddressName) {

    let $savedAddresesSection = $deliveryTabContent.find('.saved-addresses-section');
    $savedAddresesSection.empty().append(response);

    let $savedAddresesContainer = $savedAddresesSection.find('.list-group-saved-addreses');

    setSavedAddresClick($savedAddresesContainer);
    setEditAddresClick($savedAddresesContainer);
    initSavedAddressesState();

    if (selectAddressName) {
        handleAddressSelectedAfterSave($savedAddresesContainer, selectAddressName);
    }
}

/**
 * Inits saved addresses section
 */
function initSavedAddressesSection(selectAddressName) {
    const savedAddresesUrl = $deliveryTabContent.data('saved-addresses-url');

    if (savedAddresesUrl) {
        $.ajax({
            url: savedAddresesUrl,
            method: 'GET',
            success: function (response) {
                showSavedAddresesSection(response, selectAddressName);
            }
        });
    }
}

/**
 * Defines what will do when an user clicks on edit btn from a saved addres
 */
function setEditAddresClick($savedAddresesContainer) {
    $savedAddresesContainer.on('click', '.item-editbtn', function (e) {
        const currentSavedAddressClicked = $(this).closest('.list-group-item');
        addEditAddress.handleEditAddressClick.call(currentSavedAddressClicked, e);
    });

    $savedAddresesContainer.on('click', '.list-group-item.address-invalid', function (e) {
        if ($(e.target).closest('.item-editbtn').length > 0) {
            return;
        }
        e.preventDefault();
        addEditAddress.handleEditAddressClick.call(this, e);
    });
}

/**
 * Shows informative errores
 * @requires jQuery
 * @param {String} message Error text
 * @param {boolean} isFromAddressBook Flag indicating if the address comming from the address book.
 * @returns {void}
 */

function showError(message, isFromAddressBook = false) {
    if (isFromAddressBook) {
        clearErrors(isFromAddressBook);
        $('.saved-addresses-section .notification-not-in-range .notification-message').html(message);
        $('.saved-addresses-section .notification-not-in-range').removeClass('d-none');
        $('.list-group-saved-addreses').get(0).scrollIntoView({ behavior: 'smooth', block: 'end' });
    } else {
        $notificationMessage.html(message);
        $notificationContainer.removeClass('d-none');
    }
    $deliveryButton.attr('disabled', true);

}

/**
 * Removes informative errores
 * @requires jQuery
 * @param {boolean} isFromAddressBook Flag indicating if the address comming from the address book.
 * @returns {void}
 */
function clearErrors(isFromAddressBook = false) {
    $notificationMessage.text('');
    $notificationContainer.addClass('d-none');
    if (isFromAddressBook) {
        $('.saved-addresses-section .notification-has-invalid-address .notification-message').text('');
        $('.saved-addresses-section .notification-has-invalid-address').addClass('d-none');
    }
}

/**
 * Function that handles error in geolocation
 * @requires jQuery
 * @returns {void}
 */
function setLocationError() {
    showError($deliveryTabContent.find('.current-location-link').data('error'));
}

/**
 * Reset inputs and result elements
 * @requires jQuery
 * @returns {void}
 */
function reset() {
    $deliveryInput.val('');
    $deliveryButton.addClass('d-none');
    $deliveryTabContent.find('.list-group').empty();
    $deliveryLabel.addClass('d-none');
    $emptyStateHint.removeClass('d-none');
    clearErrors();
}

/**
 * Opens the delivery tab
 * @requires jQuery
 * @returns {void}
 */
function openTab() {
    $deliveryTab.addClass('active');
    $deliveryTab.parent('.nav-item').addClass('active');
    $deliveryTabContent.addClass('show active');
}

/**
 * Closes the delivery tab
 * @requires jQuery
 * @returns {void}
 */
function closeTab() {
    $deliveryTab.removeClass('active');
    $deliveryTabContent.removeClass('show active');
}

/**
 * Clears the search input
 * @requires jQuery
 * @returns {void}
 */
function handleClearIconClick() {
    const $input = $(this).siblings('input')
    $input.val('');
    $input.focus();
}

/**
 * isValidDeliveryAddress
 * @returns {boolean} isValid
 */
function isValidDeliveryAddress() {
    if (!selectedDeliveryAddress) {
        return false;
    }

    const { lat, lng, addressDetails, name, componentsModel } = selectedDeliveryAddress;
    const hasBaseFields = lat
        && lng
        && typeof addressDetails === 'string'
        && addressDetails.length
        && typeof name === 'string'
        && name.length;

    if (!hasBaseFields) {
        return false;
    }

    return addressModel.validateRequiredComponents(componentsModel).isValid;
}
/**
 * Renders the selected delivery address
 * @requires jQuery
 * @returns {void}
 */
function renderSelectedDeliveryAddress() {
    if (!selectedDeliveryAddress) {
        $deliveryLabel.addClass('d-none');
        return;
    }

    const $container = $deliveryTabContent.find('.list-group');
    $container.empty();
    $deliveryButton.removeClass('d-none');
    const isValid = isValidDeliveryAddress();

    if (isValid) {
        clearErrors();
        $deliveryButton.attr('disabled', false);
    } else {
        showError($deliveryInput.attr('data-error-incomplete-address'));
    }

    $deliveryLabel.removeClass('d-none');
    $deliveryLabel.text($deliveryLabel.attr('data-default-text'));
    $emptyStateHint.addClass('d-none');

    const iconURL = isValid
        ? $container.attr('data-icon-url')
        : $container.attr('data-not-in-range-icon');
    const itemStateClass = isValid ? 'item-selected' : 'not-in-range';

    const $newChild = $(`
        <div class="list-group-item list-group-item-action ${itemStateClass}">
            <div>
                <img src="${iconURL}" alt="location" />
            </div>
            <div>
                <h6 class="item-title">${selectedDeliveryAddress.name}</h6>
                <p class="item-text">${selectedDeliveryAddress.addressDetails}</p>
            </div>
        </div>
    `);
    $container.append($newChild);
    $container.addClass('selected-address-group');
}

/**
 * Handler when address is geocoded
 * @requires jQuery
 * @param {Object} address Address object
 * @param {string} latitude Browser latitude
 * @param {string} longitude Browsert longitude
 * @returns {void}
 */
function addressFound(address, latitude, longitude) {
    if (!address) {
        showError($('.tab-content').attr('data-location-error'));
        return;
    }

    $deliveryInput.val(address.addressDetails);
    selectedDeliveryAddress = {
        lat: latitude,
        lng: longitude,
        name: address.addressName,
        addressDetails: address.addressDetails,
        zipCode: address.zipCode,
        stateCode: address.stateCode,
        componentsModel: address.componentsModel
    };
    renderSelectedDeliveryAddress();
}

/**
* HandleDeliveryPlaceChanged
* @requires jQuery
* @param {Object} autocomplete Google autocomplete
* @returns {void}
**/
function handleDeliveryPlaceChanged (autocomplete) {
    clearErrors();
    const place = autocomplete.getPlace();
    selectedDeliveryAddress = null;

    if (place.geometry) {
        selectedDeliveryAddress = {
            name: '',
            addressDetails: '',
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };

        if (place.address_components) {
            const componentsModel = addressModel.getAddressComponents(place);
            const { addressName, addressDetails, zipCode, stateCode } = addressModel.formatAddressComponents(place);

            selectedDeliveryAddress.name = addressName;
            selectedDeliveryAddress.addressDetails = addressDetails;
            selectedDeliveryAddress.zipCode = zipCode;
            selectedDeliveryAddress.stateCode = stateCode;
            selectedDeliveryAddress.componentsModel = componentsModel;
        }

        renderSelectedDeliveryAddress();
    }
    else {
        showError($deliveryInput.attr('data-error-no-valid-location'));
    }
}

/**
* This function starts the engine for the autocomplete suggestions in the delivery address input
* @requires jQuery
* @returns {void}
**/
function initAutocomplete() {
    geocode.initAutocomplete($deliveryInput, handleDeliveryPlaceChanged);
}

/**
 * Handles redirection after successful delivery address update
 * @requires jQuery
 * @returns {void}
 */
function handleDeliverySuccess() {
    const $deliveryModal = $('#deliveryModal');
    const pdpRedirectUrl = $('.pdp-redirect-url').val();
    const successDeliveryChangeUrl = $deliveryModal.attr('data-success-redirect-url')

    if (successDeliveryChangeUrl) {
        window.location.href = successDeliveryChangeUrl;
    } else if(pdpRedirectUrl){
        $('.pdp-redirect-url').val('');
        window.location.href = pdpRedirectUrl;
    } else {
        // If no pid, just reload the page
        window.location.reload();
    }
}

/**
 * Function to handle address content when there is a coverage error.
 */
function handleCoverageError() {
    var addressItemSelected = $('.top-body-section .list-group-item.list-group-item-action:is(.item-selected, .address-selected)');
    var notInRangeIconURL = $('.list-group:is(.selected-address-group, .savedAddress-selected), .list-group').data('not-in-range-icon');
    addressItemSelected.addClass('not-in-range');
    addressItemSelected.removeClass('item-selected');
    addressItemSelected.removeClass('address-selected');
    addressItemSelected.removeClass('address-active');
    addressItemSelected.find('.item-editbtn').addClass('d-none');
    $('.list-group-item.not-in-range img').attr('src', notInRangeIconURL);
    $('.list-group-saved-addreses .not-in-range').appendTo('.list-group-saved-addreses');
}


/**
 * Handles the visual selection and reordering of a corrected address after a successful save.
 * Reuses the same classes (address-selected), icon URLs, and selectedDeliveryAddress pattern
 * as the manual click handler (setSavedAddresClick).
 * @param {jQuery} $container - The .list-group-saved-addreses container
 * @param {string} addressName - The address ID (name) to select
 * @returns {void}
 */
function handleAddressSelectedAfterSave($container, addressName) {
    const $items = $container.find('.list-group-item');
    let $targetItem = null;

    $items.each(function () {
        const $item = $(this);
        const savedAddressInfo = $item.data('address-info');
        if (savedAddressInfo && savedAddressInfo.name === addressName) {
            $targetItem = $item;
            return false;
        }
    });

    if (!$targetItem || $targetItem.length === 0) return;

    if ($targetItem.hasClass('address-active')) return;

    const $addressActive = $container.find('.address-active');
    const itemIconURL = $container.data('item-icon-url');
    const selectedItemIconURL = $container.data('selected-item-icon-url');
    const invalidAddressIconURL = $container.data('invalid-address-icon-url');

    $container.find('.list-group-item').removeClass('address-selected');
    $('.list-group.selected-address-group').find('.list-group-item').removeClass('item-selected');
    $container.find('.list-group-item').each(function () {
        const $item = $(this);
        if ($item.is($targetItem) || $item.hasClass('address-active')) return;
        const $img = $item.find('img');
        if ($item.hasClass('address-invalid')) {
            $img.attr('src', invalidAddressIconURL);
        } else if ($item.hasClass('not-in-range')) {
            $img.attr('src', $('.list-group:is(.selected-address-group, .savedAddress-selected), .list-group').data('not-in-range-icon'));
        } else {
            $img.attr('src', itemIconURL);
        }
    });

    if ($addressActive.length) {
        $targetItem.insertAfter($addressActive);
    } else {
        $targetItem.prependTo($container);
    }

    $targetItem.find('.saved-address-img').attr('src', selectedItemIconURL);
    $targetItem.addClass('address-selected');
    $deliveryButton.removeClass('d-none');
    $deliveryButton.attr('disabled', false);

    const addressInfo = $targetItem.data('address-info');
    if (addressInfo && addressInfo.lat && addressInfo.lng) {
        const location = new google.maps.LatLng(
            parseFloat(addressInfo.lat),
            parseFloat(addressInfo.lng)
        );
        SetSelectedAddresDataFromLocation(location, addressInfo);
    }
}

/**
 * Uses the latitude and longtidue to find a fulfillment store
 * @requires jQuery
 * @returns {void}
 */
function handleDeliveryButtonClick() {
    if (!selectedDeliveryAddress) {
        return;
    }

    if (!selectedDeliveryAddress.isFromAddressBook && !isValidDeliveryAddress()) {
        renderSelectedDeliveryAddress();
        return;
    }

    clearErrors();

    const componentsModel = selectedDeliveryAddress.componentsModel || {};

    $.ajax({
        url: $deliveryInput.attr('data-url'),
        type: 'post',
        dataType: 'json',
        data: {
            latitude: selectedDeliveryAddress.lat,
            longitude: selectedDeliveryAddress.lng,
            addressName: selectedDeliveryAddress.name,
            addressDetails: selectedDeliveryAddress.addressDetails,
            zipCode: selectedDeliveryAddress.zipCode || '',
            isFromAddressBook: selectedDeliveryAddress.isFromAddressBook,
            stateCode: selectedDeliveryAddress.stateCode,
            address1: componentsModel.streetName || '',
            externalNumber: componentsModel.streetNumber || '',
            neighborhood: componentsModel.neighborhood || '',
            city: componentsModel.city || ''
        },
        success: function (response) {
            if(response.success) {
                handleDeliverySuccess();
            }
            else {
                handleCoverageError();
                showError(response.errorMsg, selectedDeliveryAddress.isFromAddressBook);
            }
        },
        error: function (err) {
            showError(JSON.parse(err.responseText).message);
        }
    });
}

/**
 * Renders the saved delivery method
 * @requires jQuery
 * @param {Object} address address
 * @returns {void}
 */
function renderSelectedDeliveryMethod(address) {
    const $container = $deliveryTabContent.find('.list-group');
    const iconURL = $container.attr('data-selected-item-icon-url');

    if ($container.hasClass('savedAddress-selected')) {
        return;
    }

    const $newChild = $(`
        <div class="list-group-item list-group-item-action item-selected delivery-selected">
            <div>
                <img src="${iconURL}" alt="location" />
            </div>
            <div>
                <h6 class="item-title">${address.addressName}</h6>
                <p class="item-text">${address.addressDetails}</p>
            </div>
        </div>
    `);

    $container.append($newChild);
    $container.addClass('selected-address-group');
    $deliveryButton.removeClass('d-none');
    $deliveryButton.attr('disabled', true);
    $deliveryLabel.removeClass('d-none');
    $deliveryLabel.text($deliveryLabel.attr('data-selected-delivery-text'));
    $emptyStateHint.addClass('d-none');
}

/**
 * Initialize the delivery tab
 * @requires jQuery
 * @param {jQuery} $modal modal jquery object
 * @returns {void}
 */
function initTab($modal) {
    //Gets the container
    $deliveryTabContent = $modal.find('#delivery-tab-pane').first();
    //Assigns elements to variables
    $deliveryTab = $modal.find('#delivery-tab').first();
    $deliveryInput = $('.input-delivery').first();
    $deliveryButton = $('.change-delivery-address').first();
    $emptyStateHint = $('.empty-state-hint.delivery').first();
    $deliveryLabel = $('.modal-delivery-label').first();
    $notificationContainer = $deliveryTabContent.find('.notification--error').first();
    $notificationMessage = $deliveryTabContent.find('.notification-message').first();
    //Clear icon event
    $deliveryTabContent.find('.clear-icon').on('click', handleClearIconClick);
    //Submit event
    $deliveryButton.on('click', handleDeliveryButtonClick);

    initSavedAddressesSection();

    return $deliveryTab;
}

function openDeliveryModal(redirectUrl) {
    var $deliveryModal = $('#deliveryModal');
    if ($deliveryModal.length) {
        if (redirectUrl) {
            $deliveryModal.attr('data-success-redirect-url', redirectUrl);
        }
        $deliveryModal.modal('show');
    }
}

$(document).on('handleSelectAndRenderSelectedDeliveryAddress', async function (e, address) {
    try {
        let location;
        if (address.lat != null && address.lng != null) {
            location = new google.maps.LatLng(
                parseFloat(address.lat),
                parseFloat(address.lng)
            );
        } else {
            location = await geocode.fetchLatLngFromAddress(address.addressDetails);
        }
        if (location) {
            SetSelectedAddresDataFromLocation(location, address)
            handleDeliveryButtonClick();
        }
    } catch (error) {
        console.error(error);
    }
});

$(document).on('handleInitSavedAddressesSection', function (e, selectAddressName) {
    initSavedAddressesSection(selectAddressName);
});

$(document).on("openDeliveryModalRequest", function(event, payload) {
    openDeliveryModal(payload.redirectUrl);
});

module.exports = {
    initTab,
    initAutocomplete,
    openTab,
    closeTab,
    clearErrors,
    reset,
    addressFound,
    setLocationError,
    renderSelectedDeliveryMethod
}
